
import { defineComponent } from "vue";
import InputField from "@/views/shared/form-parts/InputField.vue";
import PullDownSelect, {
  SelectOptions,
} from "@/views/shared/form-parts/PullDownSelect.vue";
import { Product } from "@/views/order-form/order-form-interfaces";

const MAX_OPTION_UNITS = 5;

export default defineComponent({
  name: "OptionalProducts",
  props: {
    productList: {
      type: Array as () => Product[],
    },
  },
  components: {
    InputField,
    PullDownSelect,
  },
  watch: {
    optionSelectedStatus: {
      handler: function (newVal) {
        const selectedOptions = Object.entries(newVal)
          .map(([key, value]) => {
            return {
              order_option_name_id: key,
              order_option_qty: value,
            };
          })
          .filter((product) => product.order_option_qty !== "0");
        this.$emit("optionUnitUpdated", selectedOptions);
      },
      deep: true,
    },
  },
  computed: {
    maxOptionUnits(): number {
      return MAX_OPTION_UNITS;
    },
  },
  data() {
    return {
      optionSelectedStatus: {},
    };
  },
  methods: {
    prepareUnitOptions(): SelectOptions[] {
      return Array(this.maxOptionUnits + 1)
        .fill({})
        .map((elm, index): SelectOptions => {
          const label = !index ? "なし" : index + "台";
          return {
            label: label,
            value: String(index),
          };
        });
    },
    getOptionPrice(option: Product): string {
      if (Number(option.pro_taxflg)) {
        return option.pro_taxprice.toLocaleString();
      }
      return option.pro_price.toLocaleString();
    },
  },
  emits: ["optionUnitUpdated"],
});
